import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gpsSource',
})
export class GpsSourcePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (!!value) {
      switch (value) {
        case 2: return 'Android with LMU';
        case 3: return 'Android';
        case 4: return 'LMU'; // through CalAmp service
        case 5: return 'Android on behalf of LMU';
        case 6: return 'GPX';
        case 7: return 'CSV';
        case 8: return 'PlowOps Hub';
        case 9: return 'iOS on behalf of LMU';
        case 10: return 'iOS';
        default: return 'N/A';
      }
    } else {
      return 'N/A';
    }
  }

}
